// autogenerated, do not modify

export default {
  "Axios.ConnectionError": "No Internet connection. Please check your network connection and APN settings (you need “internet” in APN line).",
  "Axios.Error": "Error {status}",
  "Axios.ServerError": "Something went wrong. We're working on getting this fixed, please try again later.",
  "Axios.TimeoutError": "Server timeout error. Please try again.",
  "Common.Activate": "Activate",
  "Common.Activated": "Activated",
  "Common.AddNumberForSMS": "Add MTX Number",
  "Common.Attention": "Attention!",
  "Common.Back": "Back",
  "Common.Balance": "Balance",
  "Common.CNY": "CNY",
  "Common.Cancel": "Cancel",
  "Common.Close": "Close",
  "Common.ContactSupport": "Contact support",
  "Common.Date": "Date",
  "Common.Deactivate": "Deactivate",
  "Common.Delete": "Delete",
  "Common.Duration": "Duration",
  "Common.ESIM": "eSIM",
  "Common.EUR": "€",
  "Common.Europe": "Europe",
  "Common.Everywhere": "Everywhere",
  "Common.Friday": "Fri",
  "Common.IdentityUnverified": "You must upload a photo of your identification document (passport, national ID or driver’s license). To start using the service, please wait for your documents to be reviewed and accepted.",
  "Common.IdentityWanted": "You must upload a photo of your identification document (passport, national ID or driver’s license)",
  "Common.IdentityWantedFlashMessage": "You must <a href=\"{link}\">upload</a> a photo of your identification document (passport, national ID or driver’s license)",
  "Common.Loading": "Loading...",
  "Common.Login": "Login",
  "Common.MB": "MB",
  "Common.Mb": "Mb",
  "Common.Monday": "Mon",
  "Common.Name": "Name",
  "Common.Next": "Next",
  "Common.NoData": "no data",
  "Common.Ok": "Ok",
  "Common.Package": "Package",
  "Common.Price": "Price",
  "Common.SIM": "SIM",
  "Common.Saturday": "Sat",
  "Common.Save": "Save",
  "Common.Simcard": "Simcard",
  "Common.Sum": "Sum",
  "Common.Sunday": "Sun",
  "Common.Thursday": "Thu",
  "Common.Traffic": "Traffic",
  "Common.Tuesday": "Tue",
  "Common.Wednesday": "Wed",
  "Common.day": "d",
  "Common.hour": "h",
  "Common.minute": "m",
  "Exception.LetUsKnow": "Let us know",
  "Exception.PageNotFound": "Page Not Found. 404",
  "Exception.ReturnToHomepage": "Return to homepage",
  "Exception.ServerErrorDescription": "Try that again, and if it still doesn't work, let us know.",
  "Exception.ServerErrorTitle": "Something went wrong",
  "GDPR.AgreeBtn": "GIVE CONSENT",
  "GDPR.Attention": "Please not that in case you refuse to accept the new Privacy Policy we will not be able to provide you with our Services subject to the new regulations of the European Union.",
  "GDPR.BackLink": "Back to MTX Connect website",
  "GDPR.DisagreeBtn": "Do not give consent",
  "GDPR.Notice": "In accordance with new requirements regarding the data protection in the European Union we are updating {link} in order to protect the privacy of our customers on higher standards and to improve the security of all personal data collected from you. The amendments will help you to understand what information we may collect about you and the reasons why we are doing so; it will also give you an overview on how you can manage, update, delete or export your information.",
  "GDPR.NoticeLink": "our Privacy Policy",
  "GDPR.Request": "We kindly ask you to carefully read {link} and provide us with your consent by clicking the button below.",
  "GDPR.RequestLink": "our amended Privacy Policy",
  "GDPR.VerificationTitle": "Thank you very much for giving us your consent.",
  "History.All": "All",
  "History.Date": "Date",
  "History.Details": "Details",
  "History.DownloadReceipt": "get receipt",
  "History.EmptyHistory": "No payments history available",
  "History.EndDate": "End Date",
  "History.StartDate": "Start Date",
  "History.Sum": "Sum",
  "LogoutButton.Logout": "Logout",
  "LogoutButton.LogoutCancel": "Cancel",
  "LogoutButton.LogoutConfirmation": "Logout?",
  "LogoutButton.LogoutYes": "Yes",
  "Menu.ActivateSIM": "New SIM",
  "Menu.Connect": "Connect",
  "Menu.ContactUs": "Contact Us",
  "Menu.Coverage": "Coverage",
  "Menu.Faq": "FAQ",
  "Menu.History": "History",
  "Menu.HowItWorks": "How it works",
  "Menu.Overview": "Overview",
  "Menu.Pricing": "Pricing",
  "Menu.Profile": "Profile",
  "Menu.Support": "Support",
  "Menu.Topups": "Top-Ups",
  "OneTIme.PaymentSuccess": "Payment successful.",
  "OneTime.Amount": "Amount",
  "OneTime.EsimSentTo": "eSIM settings were also sent to:",
  "OneTime.OrderID": "Order ID:",
  "OneTime.PaidWith": "Paid with",
  "OneTime.ThankYou": "Thank you for purchasing!",
  "OneTime.WaitingEsim": "Your eSIM installation QR code will be ready in 1-2 minutes",
  "OneTimePassBuyTitle": "You are going to buy One-Time Pass offer: <b>{name}</b>",
  "OneTimePassDescription": "This eSIM is for **one-time use only**. It will deactivate once its package is used up or expires, and it cannot be reused like a regular MTX eSIM.\n\nIt won't be visible in your MTX personal account, meaning you can't manage it there.\n\n\\\n**How to use One-time Pass:**\n1. You will get a QR code.\n2. Scan it with your phone.\n3. Follow the on-screen instructions.",
  "OneTimePassDisclaimerMsg": "New disposable eSIM will be installed. It will deactivate once it's used or expired.",
  "OneTimePassDisclaimerTitle": "ONE-TIME PASS OFFERS",
  "OneTimePassLoadingMsg": "We are looking for available One-Time offers, which can take up to 2 minutes. Please be patient.",
  "OneTimePassMissingCoverage": "We are constantly working to expand our coverage. Unfortunately, we currently do not have One-Time Pass offers in {country}.",
  "Order.Acknowledge": "Acknowledge",
  "Order.Activate": "Activate a new SIM",
  "Order.ActivationCode": "Activation code",
  "Order.Attention": "Attention! You should top-up your balance to use this service.",
  "Order.AttentionCanada": "Attention: MTX Connect service cannot be used for domestic service in Canada by residents of Canada.",
  "Order.AttentionChina": "For shipment to mainland China, we need your mobile phone number, and the shipping address in Chinese character.",
  "Order.CartCaption": "You ordered {amount, plural, =0 {no {name} cards} one {# {name} card} other {# {name} cards}}, total is €{price}*",
  "Order.ChooseOption": "Choose an option",
  "Order.ChooseType": "Сhoose a SIM card type",
  "Order.CloseBtn": "Close",
  "Order.Continue": "By continuing, you agree to our <a href=\"https://www.mtxc.eu/en/terms-and-conditions.html\" target=\"_blank\">Terms and Conditions</a> and <a href=\"https://www.mtxc.eu/en/privacy-policy.html\" target=\"_blank\">Privacy Policy</a>",
  "Order.DontDeleteEsim": "Attention! Don’t delete your eSIM, because it can’t be restored. If necessary, you can temporarily deactivate the profile and reactivate it at any time ",
  "Order.DontDeleteEsimLink": "https://mtxchelp.crisp.help/en-us/article/what-do-i-do-if-i-delete-my-esim-tagfxh/",
  "Order.DontDeleteEsimLinkName": "(Details)",
  "Order.ESIMConfirmation": "I confirm that my device supports eSIM.",
  "Order.ESIMDescr": "eSIM for your eSIM compatible device for €{price} *",
  "Order.EsimCanProcess": "eSIM data download process can take up to 2 minutes.",
  "Order.EsimRequestRateExceeded": "You have exceeded the limit of one order in two minutes. If you need to make more orders, please wait.",
  "Order.EsimSent": "eSIM settings also will be sent to your email address, this window can be closed.",
  "Order.MakeSureEsim": "Please make sure your device supports eSIM! You can check this in the user manual for your smartphone or on the manufacturer’s website. In case your device is not eSIM-compatible, you can not use this service. This service can not be refunded after purchase.",
  "Order.MaxLengthExceeded": "Field {fieldName} is limited to {maxLength} characters",
  "Order.New": "Order a new SIM",
  "Order.OrderID": "Order ID: {orderId}",
  "Order.PaymentDescr": "*Prices do not include any taxes and fees. Payment will be charged from your MTX Connect balance.",
  "Order.ProceedWithOrder": "and proceed with order",
  "Order.QuotaExceededCheckbox": "Got it",
  "Order.QuotaExceededConfirmation": "You won't be able to activate a card on this account because you already have 10 active cards. <br /><br />If you need more, you can create one more account or contact <a href=\"mailto:corp@mtxc.eu\">corp@mtxc.eu</a>. We'll offer you the best solution for managing a larger number of cards.",
  "Order.SIMDescr": "3-in-1 SIM Card for €{price} *",
  "Order.SimcardsLimitExceeded": "You have ten active cards in your account.<br /><br />If you need more, you can create one more account or contact <a href=\"mailto:corp@mtxc.eu\">corp@mtxc.eu</a>. We'll offer you the best solution for managing a larger number of cards.",
  "Order.SmdpAddress": "SM-DP+ Address",
  "Order.SuccPaymentCaption": "Payment successful. Your order was accepted!",
  "Order.SuccPaymentDescr": "You will receive an email confirmation soon. {orderCaption}",
  "Order.UnsuccPaymentCaption": "Payment failed",
  "Overview.ForSelectedCard": "For selected card only",
  "Overviews.Action": "Action",
  "Overviews.ActivationCodeUsed": "SIM Card with &laquo;<strong>{code}</strong>&raquo; activation code has been successfully activated.",
  "Overviews.ActiveSince": "Active since {date}",
  "Overviews.Date": "Date",
  "Overviews.Details": "Details",
  "Overviews.Left": "left",
  "Overviews.NoActivePackage": "no active package",
  "Overviews.NoAvailableTraffic": "no available traffic",
  "Overviews.NoTimeLeft": "no time left",
  "Overviews.Remain": "REMAIN",
  "Overviews.RemainOf": "OF {remain} REMAIN",
  "Overviews.Spent": "spent",
  "Overviews.TrafficLeft": "traffic left",
  "Overviews.TrafficUsageHistory": "Traffic usage history",
  "Overviews.UnlimitedTime": "Unlimited time",
  "Overviews.UnlimitedTraffic": "Unlimited traffic",
  "Overviews.UsageHistory": "Usage history",
  "Package.Accept": "Accept",
  "Package.Active": "Active",
  "Package.AnotherPackageIsActive": "Package {activePackageName} is active. Please wait when it becomes deactivated",
  "Package.AutomaticRenewal": "Automatic renewal",
  "Package.AvailableCountries": "Available countries",
  "Package.AvailableNumbers": "Available numbers",
  "Package.Back": "Back",
  "Package.BundlesLoadFailure": "Couldn't load packages list",
  "Package.CancelRenewal": "Cancel Renewal",
  "Package.CannotSwitchTariff": "Package can't be activated",
  "Package.ConfirmActivation": "<div>You are going to activate <b>{packageName}</b> tariff plan for SIM card {cardName}.</div>",
  "Package.ConfirmActivationMobileNumber": "<div>You are going to activate <b>MTX Number subscription</b> for SIM card {cardName}.</div>",
  "Package.ConfirmActivationSubscription": "<div>You are going to activate <b>{packageName}</b> for your account.<br /><b>FreeChat option will be activated for this card: {cardName}.</b><br />If you want to run FreeChat with a different card, please press Decline, select another card and then activate <b>{packageName}</b>.</div>",
  "Package.ConfirmAgreeCheckbox": "I understand and agree",
  "Package.ConfirmAgreeText": "The MTX Number allocated to you by MTX will be auto-renewed for the same period using your account balance. Please make sure that you have sufficient account balance before the expiration of the Number.\n\nBy confirming the purchase you acknowledge accept that MTX Number does not replace your landline and cannot be used for contacting and receiving notifications from emergency services, and notably does not allow you to make calls to emergency services.\n\nThe service is provided on \"as is\" basis, meaning that SMS or calls from some mobile networks, applications, or other third-party services might not reach you. MTX Connect does not give any warranties, whether express or implied, as to the suitability or usability of the MTX Number. This service can not be refunded after purchase.",
  "Package.ConfirmAlertConsent": "Please confirm the purchase of <b>MTX Number for SIM card</b> {cardName}.",
  "Package.ConfirmAndPay": "Confirm",
  "Package.ConfirmDeactivation": "<div>You are going to deactivate <b>{packageName}</b> tariff plan for SIM card {cardName}.</div>",
  "Package.ConfirmDeactivationMobileNumber": "<div>You are going to deactivate <b>MTX Number subscription</b> for SIM card {cardName}.</div>",
  "Package.Confirmation": "Confirmation",
  "Package.ConnectPermanently": "Connect permanently",
  "Package.Day": "Days",
  "Package.Decline": "Decline",
  "Package.Done": "Done",
  "Package.EnableAnnualRenewal": "Enable automatic renewal",
  "Package.ExpiresDate": "expires {date}",
  "Package.Gb": "GB",
  "Package.GoingToStartRenewal": "The MTX Number allocated to you by MTX will be auto-renewed for the same period using your account balance or saved payment card. Please make sure that you have sufficient balance before the expiration of the Number.",
  "Package.GoingToStopRenewal": "You are going to stop auto-renewal for MTX Number {number}.",
  "Package.Hour": "Hours",
  "Package.IdentityIsNotApproved": "Your idenitiy was not verified. Please contact <a href=\"{link}\">support</a>",
  "Package.IncludeVAT": "including {currency} {difference} VAT",
  "Package.ListIsEmpty": "There are no packages to subscribe, sorry",
  "Package.Mb": "MB",
  "Package.MobileNumberHeader": "Add MTX Number to your MTX sim card",
  "Package.MobileNumberHint": "Get an MTX Number from MTX Connect and receive calls and SMS anywhere around the world.",
  "Package.MobileNumberLabel": "Annual subscription for inbound SMS and 2-way voice calls service.",
  "Package.MobileNumberPaymentHint": "Payment will be charged from your MTX Connect balance.",
  "Package.Number": "Number",
  "Package.PackageWillBeDeactivated": "<strong>Warning!</strong> <strong>{packageName}</strong> package will be deactivated!",
  "Package.PleaseTopup": "Your balance is too low. Please topup at {please_topup_page}",
  "Package.PleaseTopupPage": "topup page",
  "Package.PreviousNumbers": "Previous Numbers",
  "Package.SelectNumber": "Select Number",
  "Package.StartRenewal": "Start Renewal",
  "Package.Subscribe": "Subscribe",
  "Package.Subscribed": "Subscribed",
  "Package.SubscriptionActivationFailure": "Couldn't activate package. Please try later.",
  "Package.SubscriptionDeactivationFailure": "Couldn't deactivate package. Please try later.",
  "Package.Topup": "Top-up",
  "Package.TopupBalance": "Top-Up Balance",
  "Package.TrafficWillBeLost": "<strong>Warning!</strong> {trafficRemain}Mb from current package will be lost",
  "Package.Unsubscribe": "Unsubscribe",
  "Package.UnsubscribeWarning": "<p><b>Warning</b></p>\n<p>Automatic renewal of your subscription will be cancelled. You can still use your subscription until the next billing date. After that subscription will not automatically renew.</p>",
  "Package.perMb": "per MB",
  "Profile.ChangePassword": "Change Password",
  "Profile.ChangingPassword": "Changing password...",
  "Profile.ChooseIdentity": "Choose File",
  "Profile.City": "City",
  "Profile.CityHint": null,
  "Profile.Common": "Common",
  "Profile.ConfirmNewPassword": "Confirm New Password",
  "Profile.CopiedToClipboard": "Copied to your clipboard",
  "Profile.Copy": "Copy referral link",
  "Profile.Country": "Country",
  "Profile.CurrentPassword": "Current Password",
  "Profile.DeliveryAddress": "Delivery Address",
  "Profile.DeliveryType": "Delivery method",
  "Profile.DetailedAddress": "Detailed Address",
  "Profile.District": "District",
  "Profile.Email": "Email",
  "Profile.EmailAddress": "Email Address",
  "Profile.FirstName": "First Name",
  "Profile.FirstNameHint": null,
  "Profile.FloorUnit": "Apartment",
  "Profile.FloorUnitHint": null,
  "Profile.GetRefferal": "Get referral code",
  "Profile.IdentityPlaceholder": "Upload your ID scan",
  "Profile.IdentityStatus": "Status",
  "Profile.IdentityStatusAccepted": "Verified",
  "Profile.IdentityStatusLoaded": "Loaded",
  "Profile.IdentityStatusPending": "Waiting for upload",
  "Profile.IdentityStatusRejected": "Rejected",
  "Profile.IdentityStatusUnknown": "Upload again",
  "Profile.IdentityTitle": "Identification Document",
  "Profile.LastName": "Last Name",
  "Profile.LastNameHint": null,
  "Profile.Login": "Login",
  "Profile.NewPassword": "New Password",
  "Profile.NoIdentity": "File is not chosen",
  "Profile.NonLatinError": "Only latin characters, numbers and punctuation marks are allowed",
  "Profile.PasswordChangeFail": "Failed to change password",
  "Profile.PasswordChangeSuccess": "Password was successfuly changed",
  "Profile.PasswordsDontMatch": "Passwords don't match",
  "Profile.Phone1": "Phone",
  "Profile.PhoneHint": null,
  "Profile.PleaseFillNewPassword": "Please fill in new password",
  "Profile.PleaseFillPassword": "Please fill in current password",
  "Profile.Province": "Province",
  "Profile.Referral": "Referral code",
  "Profile.Region": "Region",
  "Profile.RegionHint": null,
  "Profile.Street": "Street",
  "Profile.StreetAndNumber": "Street and Number",
  "Profile.StreetHint": null,
  "Profile.StreetNumber": "House",
  "Profile.StreetUnit": "Building",
  "Profile.StreetUnitHint": null,
  "Profile.TermsOfServices": "By clicking \"Next\", you agree to our <a href=\"https://www.mtxc.eu/en/terms-and-conditions.html\" target=\"_blank\">Terms and Conditions</a> and that you have read our <a href=\"https://www.mtxc.eu/en/privacy-policy.html\" target=\"_blank\">Privacy Policy</a>",
  "Profile.TheCurrentPasswordIsIncorrect": "The current password is incorrect",
  "Profile.UpdateFailed": "Profile failed to update!",
  "Profile.UpdateProfile": "Update Profile",
  "Profile.UpdatedSuccessfully": "Profile was successfully updated!",
  "Profile.UpdatingProfile": "Updating...",
  "Profile.UploadingIdentity": "Uploading:",
  "Profile.ZipCode": "ZIP Code",
  "Shared.ActivePackage": "Active package",
  "Shared.ActiveTill": "active until {date}",
  "Shared.AddSIM": "New SIM",
  "Shared.ApiError": "Oops, something went wrong. Please ",
  "Shared.ApiErrorLink": "reload the page",
  "Shared.Back": "Back",
  "Shared.BonusPackage": "Bonus package",
  "Shared.CardIsSuspended": "This SIM card is suspended. Please, contact our <a href=\"{link}\">customer service</a> to unblock if necessary.",
  "Shared.ConnectAndStartUsing": "Connect & Start using data",
  "Shared.CurrentPackageIs": "Current package {packageName} is active till {date}",
  "Shared.ErrorGettingTestSmsCount": "Failed to get test SMS count",
  "Shared.ErrorLoadingPage": "Error loading page",
  "Shared.ErrorPhoneMsg": "Please use valid phone number",
  "Shared.FillAllAddressFields": "Highlighted fields are required",
  "Shared.Location": "Location",
  "Shared.NextPackage": "Next",
  "Shared.PackageToBeActive": "Package to be Active in Europe: ",
  "Shared.Rename": "Rename",
  "Shared.Sure": "Sure?",
  "Shared.Suspend": "Suspend",
  "Shared.TestSmsButton": "Test SMS",
  "Shared.TestSmsLeft": "Test SMS {left} remaining",
  "Shared.Unsuspend": "Unsuspend will be able only with request to <a href=\"mailto:help@mtxc.eu\">help@mtxc.eu</a>",
  "Shared.UploadError": "Upload failed. Please send your identity to: support@mtxc.eu",
  "Shared.UploadWrongFormat": "File should be in jpg format",
  "Simcards.ActivateSIM": "Activate SIM",
  "Simcards.ActivateSimCard": "Activate simcard before using control panel",
  "Simcards.EmptyActivationCode": "Please fill in activation code",
  "Simcards.EnterCode": "Please enter activation code below",
  "Simcards.ErrorLoadingPrices": "Failed to load prices",
  "Simcards.FindActivationCode": "You can find the activation code on the backside of your MTXC simcard:",
  "Simcards.SimcardNotActivated": "Failed to activate SIM card",
  "Simcards.WrongFormatActivationCode": "Activation code is invalid",
  "Support.Buffered": "Your message successfully sent to customer service. We will get back to you as soon as possible. The answer will be sent by email and into your personal account.",
  "Support.BufferedCn": "Your message successfully sent to customer service. We will get back to you as soon as possible. The answer will be sent by email/SMS and into your personal account.",
  "Support.CreateCommentError": "Failed to create comment. Please try again later or contact us by email at support@mtxc.eu",
  "Support.CreateTicketError": "Failed to create ticket. Please try again later or contact us by email at support@mtxc.eu",
  "Support.Date": "Date",
  "Support.LoadMoreBtn": "Load more",
  "Support.Message": "Message",
  "Support.Send": "Send",
  "Support.Sending": "Sending...",
  "Support.Topic": "Topic",
  "TermsAnPrivacy": "By clicking <b>\"Accept\"</b>, I certify that agree to the <a href=\"{terms_url}\" target=\"_blank\"><b>Terms and Conditions</b></a> and <a href=\"{privacy_url}\" target=\"_blank\"><b>Privacy Policy</b></a>.",
  "Topup.AliPay": "AliPay",
  "Topup.AliPayRedirecting": "Redirecting to AliPay...",
  "Topup.AliPayWarning": "Payments made via Alipay may be delayed for up to 24 hours.<br />Please choose another payment option if you need the order to be processed immediately.",
  "Topup.Amount": "Charge Amount",
  "Topup.AmountTitle": "Top-up amount, €",
  "Topup.AmountWord": "Amount {amount} {currency}",
  "Topup.ApplePayBtn": "Buy with",
  "Topup.ByCard": "Credit Card",
  "Topup.CVC": "CVC",
  "Topup.CardCvv": "Please enter CVV:",
  "Topup.CardDetails": "Card details:",
  "Topup.CardHolderName": "CARDHOLDER NAME",
  "Topup.CardNew": "New card",
  "Topup.CardNumber": "Card Number",
  "Topup.CardSaved": "Saved cards",
  "Topup.EnterVoucherCode": "Enter Voucher code",
  "Topup.ExchangeNotice": "The actual charged amount may vary due to the exchange rate differecnes. If you see any discrepancy, please contact our support.",
  "Topup.GettingToken": "Getting token...",
  "Topup.InsufficientFunds": "Insufficient funds",
  "Topup.MM": "MM",
  "Topup.MakePayment": "Make Payment",
  "Topup.Megapay": "567",
  "Topup.PaidWith": "Paid with {paymentMethod}",
  "Topup.PayByVoucher": "Pay by Voucher",
  "Topup.PayPal": "PayPal",
  "Topup.PayPalPayment": "Make Payment with PayPal",
  "Topup.PayPalProceed": "Proceed to pay {amount} {currency_code} with PayPal",
  "Topup.PaymentInProgress": "Payment in progress...",
  "Topup.RefillCard": "Payment failed. Please re-enter your billing information. We changed the payment gateway, and you need to add a payment card again to top up the balance.",
  "Topup.RememberCard": "Remember this card",
  "Topup.Saving": "Saving...",
  "Topup.SpecifyAddress": "Before you pay, please specify the billing address",
  "Topup.StoredCard.EnterCVV": "Please enter CCV code",
  "Topup.StoredCard.Pay": "Pay",
  "Topup.StoredCard.StoredCards": "Stored Cards",
  "Topup.StoredCard.UseCard": "Use this card",
  "Topup.SubmittingCode": "Submitting code...",
  "Topup.SuccessfulPaymentDescrEmail": "You will receive an email confirmation soon.",
  "Topup.SuccessfulPaymentDescrSMS": "You will receive an SMS confirmation soon.",
  "Topup.SuccessfulPaymentHeader": "Payment successful, your order was accepted!",
  "Topup.SuccessfulPaymentPayAgain": "Pay again",
  "Topup.SuccessfulPaymentTransaction": "Transaction ID: {transactionId}",
  "Topup.SuccessfulPaymentTryAgain": "Please try again",
  "Topup.TakeCareText": "We care about our customers’ safety and store no card details.",
  "Topup.UnsuccessfulPaymentHeader": "Your payment failed.",
  "Topup.UseCardToAutoSubscriptionRenewal": "Use this card for automatic subscription renewal if there are insufficient funds",
  "Topup.UseCardToAutoTopup": "Use this card for automatic top-up when the balance falls below €2",
  "Topup.ValidThru": "Expires",
  "Topup.Voucher": "Voucher",
  "Topup.YY": "YY",
  "autorenew.subscription.disable": "You are going to stop auto-renewal for {name} subscription.",
  "autorenew.subscription.enable": "The {name} subscription will be auto-renewed for the same period using your account balance or saved payment card. Please make sure that you have sufficient balance before the expiration of the subscription.",
}



// WEBPACK FOOTER //
// ./app/javascript/components/locales/en.js